<template>
    <input type="file" class="esesja-input-file" @change="(e) => $emit('change', e)" :multiple="isMultiple" />
</template>
<script charset="utf-8">
    export default {
        name: "InputFileComponent",
        emits: ["change"],
        props: {
            isMultiple: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>
<style lang="scss">
    .esesja-input-file {
        padding: 12.5px 16px;
        background: #ffffff;
        border: 1px solid #d1d6df;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
        border-radius: 4px;
        margin-top: 8px;
        font-size: 16px;
        line-height: 144%;
        color: #00082c;
        width: 100%;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;

        &::file-selector-button {
            background: #fff;
            padding: 12.5px 15px;
            border: none;
            transition: all 0.2s ease-in-out;
            cursor: pointer;

            &:hover {
                background: #e8ebef;
            }
        }
    }
</style>